import { render, staticRenderFns } from "./SmallOverview.vue?vue&type=template&id=064924a2&"
import script from "./SmallOverview.vue?vue&type=script&lang=ts&"
export * from "./SmallOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports